import gql from 'graphql-tag';

export const findByEnterprisePromotionIdQuery = gql`
  query FindByEnterprisePromotionIdQuery($id: String!) {
    PromotionsV3Resource {
      byEnterprisePromotionId(id: $id) {
        elements {
          promotionName
          discountPercent
          startsAt
          id
          endsAt
          promotionId
        }
      }
    }
  }
`;
